module.exports = __webpack_public_path__ + "static/media/damage.6bc015f9.png";